/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DiscoverRelationshipsRequest
 */
export interface DiscoverRelationshipsRequest {
    /**
     * 
     * @type {string}
     * @memberof DiscoverRelationshipsRequest
     */
    entityType?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscoverRelationshipsRequest
     */
    entityId?: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof DiscoverRelationshipsRequest
     */
    entityData?: { [key: string]: any; };
}

/**
 * Check if a given object implements the DiscoverRelationshipsRequest interface.
 */
export function instanceOfDiscoverRelationshipsRequest(value: object): value is DiscoverRelationshipsRequest {
    return true;
}

export function DiscoverRelationshipsRequestFromJSON(json: any): DiscoverRelationshipsRequest {
    return DiscoverRelationshipsRequestFromJSONTyped(json, false);
}

export function DiscoverRelationshipsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): DiscoverRelationshipsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'entityType': json['entityType'] == null ? undefined : json['entityType'],
        'entityId': json['entityId'] == null ? undefined : json['entityId'],
        'entityData': json['entityData'] == null ? undefined : json['entityData'],
    };
}

export function DiscoverRelationshipsRequestToJSON(json: any): DiscoverRelationshipsRequest {
    return DiscoverRelationshipsRequestToJSONTyped(json, false);
}

export function DiscoverRelationshipsRequestToJSONTyped(value?: DiscoverRelationshipsRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'entityType': value['entityType'],
        'entityId': value['entityId'],
        'entityData': value['entityData'],
    };
}

